module.exports = __FOREMAN_VENDOR__REACT_REDUX__;